export const BOL_API_INIT = 'BOL_API_INIT';
export const BOL_API_SUCCESS = "BOL_API_SUCCESS";
export const BOL_API_FAILURE = "BOL_API_FAILURE";

export const AZURE_RETRIEVE_TOKEN_INIT = 'AZURE_RETRIEVE_TOKEN_INIT';
export const AZURE_RETRIEVE_TOKEN_SUCCESS = "AZURE_RETRIEVE_TOKEN_SUCCESS";
export const AZURE_RETRIEVE_TOKEN_FAILURE = "AZURE_RETRIEVE_TOKEN_FAILURE";
